"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LinksCarouselLayout = require("./LinksCarouselLayout");
Object.keys(_LinksCarouselLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LinksCarouselLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LinksCarouselLayout[key];
    }
  });
});
